import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
function FormLink({
  formName,
  formId,
  portalId
}) {
  const formHref = `/forms/${portalId}/editor/${formId}/edit/form`;
  return /*#__PURE__*/_jsx(Link, {
    href: formHref,
    target: "_blank",
    children: formName
  });
}
FormLink.displayName = 'FormLink';
export default FormLink;